
  const buttons = document.querySelectorAll('.TSV2_btn');

  let currentSpeech = null;
  let isPaused = false;

  const playIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="23" viewBox="0 0 18 23" fill="none">
      <path d="M0.0924678 -0.00946001L17.918 11.083L0.0924594 22.1751L0.0924678 -0.00946001Z" fill="white"></path>
    </svg>
  `;

  const pauseIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="23" viewBox="0 0 18 23" fill="none">
      <rect x="2" y="2" width="4" height="19" fill="white"></rect>
      <rect x="12" y="2" width="4" height="19" fill="white"></rect>
    </svg>
  `;

  buttons.forEach((button) => {
    const originalText = button.textContent.trim(); // Save initial button text ("Listen")

    button.addEventListener('click', (e) => {
      if (button.hasAttribute('data-apple-podcast-modal')) {
        return;
      }

      if (button.tagName === 'A') {
        const href = button.getAttribute('href') || '';
        if (/^https?:\/\//i.test(href)) {
          return;
        }
      }

      e.preventDefault();
      e.stopPropagation();

      const textElement = button.parentElement.querySelector('.TSV2_Text');
      if (!textElement) return;

      const text = textElement.textContent.trim();

      if (window.speechSynthesis.speaking) {
        if (isPaused) {
          window.speechSynthesis.resume();
          isPaused = false;
          button.innerHTML = `Pause ${pauseIcon}`;
        } else {
          window.speechSynthesis.pause();
          isPaused = true;
          button.innerHTML = `Listen ${playIcon}`;
        }
      } else {
        currentSpeech = new SpeechSynthesisUtterance(text);

        window.speechSynthesis.cancel();
        window.speechSynthesis.speak(currentSpeech);

        isPaused = false;
        button.innerHTML = `Pause ${pauseIcon}`;

        currentSpeech.onend = () => {
          isPaused = false;
          button.innerHTML = `Listen ${playIcon}`;
        };

        currentSpeech.onerror = () => {
          isPaused = false;
          button.innerHTML = `Listen ${playIcon}`;
        };
      }
    });
  });

